import { useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from 'react-router-dom';
import {
  Grid,
  TextField,
  Card,
  FormControl,
  MenuItem,
  Select,
  OutlinedInput,
  InputLabel,
  Checkbox,
  ListItemText,
  FormHelperText,
  Box,
  CardContent,
  useMediaQuery,
  CircularProgress,
  styled
} from "@mui/material";
import "./Modifmission.css";
import "./Addmission.css";
import { addMission, editMission, getDetailsForModification } from "../../services/MissionService";
import { getAllCompetencesMetiersForSelect } from "../../services/CompetenceMetierService";
import { getAllCompetencesSectoriellesForSelect } from "../../services/CompetenceSectorielleService";
import { getAllExperiencesMissionForSelect } from "../../services/ExperienceMissionService";
import { getAllFormationsMissionForSelect } from "../../services/FormationMissionService";
import { getAllNiveauxAnglaisForSelect } from "../../services/NiveauAnglaisService";
import { getAllStatutsMissionForSelect } from "../../services/StatutMissionService";
import { getAllTypesMissionForSelect } from "../../services/TypeMissionService";
import { getConsultantsAndManagers } from "../../services/UserService";
import { getAllContactsInSocieteForMission, getDetails } from "../../services/SocieteService";
import Loader from "../../components/Loader/Loader";
import SaveBar from "../Candidat/CandidatForm/Components/SaveBar";
import { theme } from "../../utils/Theme";
import { withSnackbar } from "../../utils/SnackbarHOC";
import EditorCustom from "../../components/EditorCustorm/EditorCustom";
import { removeLineBreak } from "../../utils/EditorUtil";
import { v4 } from "uuid";
import { contrats } from "../../utils/ContratUtil";
import {addLocation, getLocations} from "../../services/CandidatService";
import { Autocomplete } from "@mui/material";
import { pourvoirs } from "../../utils/PourvoirUtils";

const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: "#fff",
  borderRadius: "10px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
}));

const LoadingProgress = styled(CircularProgress)({
  color: "white",
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: -12,
  marginLeft: -12,
});

const FormSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: "100%",
  marginBottom: theme.spacing(2),
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const FormMission = ({ editMode, snackbarShowMessage }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [dataForSelects, setDataForSelects] = useState({
    competencesMetiers: [],
    competencesSecto: [],
    experiencesMission: [],
    formationsMission: [],
    niveauxAnglais: [],
    statutsMission: [],
    typeMissions: [],
    contactsInSociete: [],
    managers: [],
    deliveryManagers: [],
    talentManagers: [],
  })
  const [societe, setSociete] = useState({});
  const [nomSociete, setNomSociete] = useState("");

  const mounted = useRef(false);
  const [errors, setErrors] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const [loadingDataForSelect, setLoadingDataForSelect] = useState(true);
  const { id, idMission } = useParams();
  const [nomMission, setNomMission] = useState("");
  const [statut, setStatut] = useState("");
  const [typeMission, setTypeMission] = useState("");
  const [destinatairePrincipale, setDestinatairePrincipale] = useState("");
  const [destinataireSecondaire, setDestinataireSecondaire] = useState([]);
  const [manager, setManager] = useState("");
  const [sourceur, setSourceur] = useState("");
  const [consultant, setConsultant] = useState("");
  const [poste, setPoste] = useState("");
  const [experience, setExperience] = useState([]);
  const [formation, setFormation] = useState("72179945-cfda-4e33-8710-7223d18942c8");
  const [sectorielle, setSectorielle] = useState([]);
  const [metier, setMetier] = useState([]);
  const [technique, setTechnique] = useState("");
  const [niveauAnglais, setNiveauAnglais] = useState("9e639474-2d43-4bee-8f7a-66c33afe95ea");
  const [descriptionSociete, setDescriptionSociete] = useState("");
  const [pitchMission, setPitchMission] = useState("");
  const [remuneration, setRemuneration] = useState("");
  const [contactsInSociete, setContactsInSociete] = useState([]);
  const location = useLocation();
  const [priorite, setPriorite] = useState('');
  const [localisation, setLocalisation] = useState('');
  const [status, setStatus] = useState('');
  const [pourvoir, setPourvoir] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [villes, setVilles] = useState([]);
  const [nbPostes, setNbPostes] = useState(null);

  const validate = () => {
    let temp = {};
    temp.nomMission = nomMission ? "" : "Le champ 'NOM DE LA MISSION' est obligatoire.";
    temp.statut = statut ? "" : "Le champ 'STATUT' est obligatoire.";
    temp.typeMission = typeMission ? "" : "Le champ 'TYPE DE LA MISSION' est obligatoire.";
    temp.principales = destinatairePrincipale.length > 0 ? "" : "1 'DESTINATAIRE PRINCIPALE' est obligatoire";
    temp.priorite = priorite ? "" : "Le champ 'PRIORITE' est obligatoire.";

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  useEffect(() => {
    let isActive = true;
    (async () => {
      setLoading(true);
      try {
        let societeData = await getDetails(id);
        if (!isActive) {
          return;
        }
        setSociete(societeData.data);
        setLoading(false);
      } catch (error) {
        if (!isActive) {
          return;
        }
        setLoading(false);
        history.push({
          pathName: "/accueil",
        });
      }
    })();

    if (!isActive) {
      return;
    }

    return () => {
      isActive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    let active = true;
    mounted.current = true;
    (async () => {
      setLoadingDataForSelect(true);

      try {
        const [
          metierReponse,
          sectoResponse,
          experienceReponse,
          formationReponse,
          niveauxAnglaisReponse,
          statutMissionReponse,
          typeMissionReponse,
          consultantsManagersResponse,
          deliveryManagersResponse,
          talentManagersResponse,
          contactResponse
        ] = await Promise.all([
          getAllCompetencesMetiersForSelect(),
          getAllCompetencesSectoriellesForSelect(),
          getAllExperiencesMissionForSelect(),
          getAllFormationsMissionForSelect(),
          getAllNiveauxAnglaisForSelect(),
          getAllStatutsMissionForSelect(),
          getAllTypesMissionForSelect(),
          getConsultantsAndManagers(),
          getConsultantsAndManagers('ROLE_DELIVERY_MANAGER'),
          getConsultantsAndManagers('ROLE_TALENT_MANAGER'),
          getAllContactsInSocieteForMission(id)
        ]);

        if (!active) {
          return;
        }

        setDataForSelects({
          competencesMetiers: metierReponse.data,
          competencesSecto: sectoResponse.data,
          experiencesMission: experienceReponse.data,
          formationsMission: formationReponse.data,
          niveauxAnglais: niveauxAnglaisReponse.data,
          statutsMission: statutMissionReponse.data,
          typeMissions: typeMissionReponse.data,
          managers: consultantsManagersResponse.data.managers
              .slice()
              .sort((a, b) => a.user.localeCompare(b.user, 'fr', { sensitivity: 'base' })),
          deliveryManagers: deliveryManagersResponse.data.managers
              .slice()
              .sort((a, b) => a.user.localeCompare(b.user, 'fr', { sensitivity: 'base' })),
          talentManagers: talentManagersResponse.data.managers
              .slice()
              .sort((a, b) => a.user.localeCompare(b.user, 'fr', { sensitivity: 'base' })),
          contactsInSociete: contactResponse.data
              .slice()
              .sort((a, b) => a.nom.localeCompare(b.nom, 'fr', { sensitivity: 'base' })),
        });
        setContactsInSociete(contactResponse.data
            .slice()
            .sort((a, b) => a.nom.localeCompare(b.nom, 'fr', { sensitivity: 'base' }))
        );
        setLoadingDataForSelect(false);
      } catch (error) {
        if (!active) {
          return;
        }
        snackbarShowMessage("Erreur de chargement des listes.", "error", 4000);
        setLoadingDataForSelect(false);
      }

    })();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let active = true;
    if (editMode) {
      (async () => {
        setLoadingData(true);
        try {
          const response = await getDetailsForModification(idMission);
          if (!active) {
            return;
          }
          setNomMission(response.data.nom_mission);
          setSourceur(response.data.sourceurId);
          setConsultant(response.data.consultantId);
          setManager(response.data.managerId);
          setPoste(response.data.poste);
          setFormation(response.data.formationId);
          setSectorielle(response.data.secteurId);
          setMetier(response.data.metierId);
          setTechnique(response.data.competence_tech);
          setNiveauAnglais(response.data.niveauId);
          setDescriptionSociete(response.data.description_societe);
          setTypeMission(response.data.typeId);
          setStatut(response.data.statutId);
          setDestinatairePrincipale(response.data.principale);
          setDestinataireSecondaire(response.data.secondaires);
          setExperience(response.data.experienceId);
          setRemuneration(response.data.renumeration);
          setPitchMission(response.data.pitch_mission);
          setPriorite(response.data.priorite);
          setLocalisation(response.data.localisation);
          setStatus(response.data.status);
          setNbPostes(response.data.nb_postes)
          setLoadingData(false);
          setPourvoir(response.data.pourvoir)
        } catch (error) {
          if (!active) {
            return;
          }
          setLoadingData(false);
          snackbarShowMessage(error.message, "error");
        }
      })();
    }
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idMission]);

  const handleSubmit = () => {
    if (validate()) {
      (async () => {
        setLoading(true);
        const data = {
          nom_mission: nomMission,
          statut,
          priorite,
          localisation: localisation,
          status: status,
          type_mission: typeMission,
          societe: id,
          accountManager: manager,
          consultant: consultant,
          sourceur: sourceur,
          destinatairePrincipale: destinatairePrincipale,
          destinataireSecondaire: destinataireSecondaire,
          poste: removeLineBreak(poste),
          experience: experience,
          formation: formation,
          competence_sectrori: sectorielle,
          competence_metiers: metier,
          competence_tech: technique,
          nv_anglais: niveauAnglais,
          descriptionSociete: removeLineBreak(descriptionSociete),
          renumeration: remuneration,
          pitch_mission: removeLineBreak(pitchMission),
          nb_postes: nbPostes,
          pourvoir: pourvoir
        };
        try {
          snackbarShowMessage("Patientez svp!", "warning", null)
          const response = await addMission(data);
          snackbarShowMessage("Mission bien ajouté!", "success", 4000)
          if (!mounted.current) {
            return;
          }
          setLoading(false);
          const newMissionId =
              response?.data?.missionId ??
              response?.data?.uuid ??
              response?.data?.id;

          history.replace(`/societe/${id}/missions/${newMissionId}/view`);
        } catch (error) {
          if (!mounted.current)
            return;
          const errorMessage = error?.response?.data?.error?.detail || "Une erreur est survenue.";
          snackbarShowMessage(errorMessage, "error", 4000);
        }
      })();
    }
  };

  useEffect(() => {
    let isActive = true;
    (async () => {
      setLoading(true);
      try {
        let { data } = await getDetails(id);

        if (!isActive) {
          return;
        }
        setSociete(data);
        setDescriptionSociete(data.description_societe);
        setLoading(false);
      } catch (error) {
        if (!isActive) {
          return;
        }
        setLoading(false);
        history.push({
          pathName: "/accueil",
        });
      }
    })();



    if (!isActive) {
      return;
    }

    return () => {
      isActive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const locations = await getLocations();
        setVilles(locations.data
            .slice()
            .sort((a, b) => a.nom.localeCompare(b.nom, 'fr', { sensitivity: 'base' }))
        );
      } catch (error) {
        console.error('Error fetching locations:', error);
      }
    };

    fetchLocations();
  }, [inputValue]);

  const handleAddCity = async () => {
    if (inputValue.trim() && !villes.find(ville => ville.name.toLowerCase() === inputValue.toLowerCase())) {
      try {
        const newCity = await addLocation({ name: inputValue });
        setVilles(prev => [...prev, newCity]
            .sort((a, b) => a.nom.localeCompare(b.nom, 'fr', { sensitivity: 'base' }))
        );
        setLocalisation(newCity.uuid);
        setInputValue('');
      } catch (error) {
        console.error('Error adding city:', error);
      }
    }
  };

  const checkDestinataireSecondaire = (value) => {
    let contacts = dataForSelects.contactsInSociete.filter((item) => item.uuid !== value);
    setContactsInSociete(contacts);
    if (contacts.length < 1) {
      contacts = "";
    }
  };
  const handleUpdate = () => {
    if (validate()) {
      (async () => {
        setLoading(true);
        const data = {
          nom_mission: nomMission,
          statut,
          priorite,
          localisation: localisation,
          status: status,
          type_mission: typeMission,
          societe: id,
          accountManager: manager,
          consultant: consultant,
          sourceur: sourceur,
          destinatairePrincipale: destinatairePrincipale,
          destinataireSecondaire: destinataireSecondaire,
          poste: removeLineBreak(poste),
          experience: experience,
          formation: formation,
          competence_sectrori: sectorielle,
          competence_metiers: metier,
          competence_tech: technique,
          nv_anglais: niveauAnglais,
          descriptionSociete: removeLineBreak(descriptionSociete),
          renumeration: remuneration,
          pitch_mission: removeLineBreak(pitchMission),
          nb_postes: nbPostes,
          pourvoir: pourvoir
        };
        try {
          snackbarShowMessage("Patientez svp!", "warning", null)
          const response = await editMission(data, idMission);
          snackbarShowMessage("Mission a été mise à jour!", "success", 4000)
          if (!mounted.current) {
            return;
          }
          history.push({
            pathname: `/societe/${id}/missions/${response.data.missionId}/view`,
            state: {
              nomSociete,
            },
          });
        } catch (error) {
          if (!mounted.current)
            return;
          const errorMessage = error?.response?.data?.error?.detail
              || "Une erreur est survenue.";
          snackbarShowMessage(errorMessage, "error", 4000);
          setLoading(false);
        }
      })();
    }
  };

  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));

  const handleChangeExeperince = (event) => {
    setExperience(event.target.value);
  }

  const saveBarProps = {
    handleSubmit,
    editMode,
    handleEdit: handleUpdate,
    loading,
  }

  const editorCustomPitchMissionProps = {
    value: pitchMission,
    setValue: setPitchMission,
    enableOnBlur: false,
  };


  const editorCustomDescriptionProps = {
    value: descriptionSociete,
    setValue: setDescriptionSociete,
    enableOnBlur: false,
  };

  const editorCustomPosteProps = {
    value: poste,
    setValue: setPoste,
    handleSubmit,
    enableOnBlur: false,
  };

  return (
    <Box className="crm-form-page crm-form-page-mission">
      {loadingData & editMode ? (
        <Loader />
      ) : (
        <>
          {loadingDataForSelect ? (
            <Loader />
          ) : (
            <>
              <Box className="candidatedit_header">
                <Grid container spacing={1} direction={isSmMode ? "column-reverse" : "row"} >
                  <Grid item xs={12} sm={6} md={6} xl={6}>
                    <h4 style={{ color: "rgb(103 107 132)" }}>{(location?.state?.numMission ? 'N°' + location?.state?.numMission + '-' : "") + societe.nom_societe}</h4>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} xl={6}>
                    <SaveBar item {...saveBarProps} />
                  </Grid>
                </Grid>
              </Box>
              <Box className="candidatedit_container mission-form-container">
                <Grid container spacing={1} alignItems={"stretch"} className="mission-form-grid">
                  <Grid item xs={12} sm={6} className="mission-form-column mission-form-column-main">
                    <StyledCard className="mission-form-card mission-form-card-core" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                      <CardContent className="mission-form-card-content" style={{ flex: 1 }}>
                        <div className="mission-form-card-titleBlock">
                          <span className="mission-form-card-kicker">01</span>
                          <h3>Essentiel mission</h3>
                          <p>Nom, statut, priorite et responsables principaux.</p>
                        </div>
                        <label className="input-label" htmlFor="NOM DE LA MISSION">
                          NOM DE LA MISSION <span className="required-input">*</span>
                        </label>
                        <StyledTextField
                          name="NOM DE LA MISSION"
                          value={nomMission}
                          onChange={(e) => setNomMission(e.target.value)}
                          placeholder="nom"
                          margin="normal"
                          variant="outlined"
                          autoComplete="off"
                          fullWidth={true}
                          {...(errors.nomMission && { error: true, label: errors.nomMission })}
                        />
                        {[
                          {
                            label: (
                              <>
                                TYPE DE MISSION <span style={{ color: 'red' }}>*</span>
                              </>
                            ),
                            name: "typeMission",
                            value: typeMission,
                            onChange: (e) => setTypeMission(e.target.value),
                            type: "Select",
                            options: dataForSelects.typeMissions,
                            selectLabel: "type",
                            defaultValue: "",
                            fullWidth: true,
                            ...(errors.typeMission && { error: true }),
                          },
                          {
                            label: (
                                <>
                                  NOMBRE DE POSTES <span style={{ color: 'red' }}>*</span>
                                </>
                            ),
                            name: "nb_postes",
                            value: nbPostes,
                            onChange: (e) => setNbPostes(e.target.value),
                            type: "NumberInput",
                            defaultValue: "",
                            fullWidth: true,
                            ...(errors.nb_postes && { error: true }),
                          },
                          {
                            label: (
                              <>
                                STATUT <span style={{ color: 'red' }}>*</span>
                              </>
                            ),
                            name: "statut",
                            value: statut,
                            onChange: (e) => setStatut(e.target.value),
                            type: "Select",
                            options: dataForSelects.statutsMission,
                            selectLabel: "statut",
                            defaultValue: "AUTRES",
                            fullWidth: true,
                            ...(errors.statut && { error: true }),
                          },
                          {
                            label: (
                              <>
                                PRIORITE <span style={{ color: 'red' }}>*</span>
                              </>
                            ),
                            name: "priorite",
                            value: priorite,
                            onChange: (e) => setPriorite(e.target.value),
                            type: "Select",
                            options: [{ uuid: '1', label: '1' }, { uuid: '2', label: '2' }, { uuid: '3', label: '3' }],
                            selectLabel: "label",
                            defaultValue: "",
                            fullWidth: true,
                            ...(errors.priorite && { error: true }),
                          },
                          {
                            label: "DELIVERY MANAGER",
                            name: "manager",
                            value: manager,
                            onChange: (e) => setManager(e.target.value),
                            type: "Select",
                            options: dataForSelects.deliveryManagers,
                            selectLabel: "user",
                            fullWidth: true,
                            ...(errors.manager && { error: true }),
                          },
                          {
                            label: "TALENT MANAGER",
                            name: "consultant",
                            value: consultant,
                            onChange: (e) => setConsultant(e.target.value),
                            type: "Select",
                            options: dataForSelects.talentManagers,
                            selectLabel: "user",
                            fullWidth: true,
                            ...(errors.manager && { error: true }),
                          },
                          {
                            label: "SOURCEUR",
                            name: "sourceur",
                            value: sourceur,
                            onChange: (e) => setSourceur(e.target.value),
                            type: "Select",
                            options: dataForSelects.managers,
                            selectLabel: "user",
                            fullWidth: true,
                            ...(errors.manager && { error: true }),
                          }
                        ].map((field, index) => (
                          <div key={v4()}>
                            <label className="input-label" htmlFor={field.name}>
                              {field.label} {field.required && <span className="required-input">*</span>}
                            </label>
                            {field.type === "NumberInput" && (
                                <StyledTextField
                                    type="number"
                                    name={field.name}
                                    value={field.value}
                                    onChange={field.onChange}
                                    placeholder={field.placeholder}
                                    margin="normal"
                                    variant="outlined"
                                    autoComplete="off"
                                    fullWidth={true}
                                    required
                                />
                            )}
                            {field.type === "Select" && (
                              <StyledFormControl variant="outlined" fullWidth margin="normal">
                                <InputLabel {...(field.error && { error: true })}>
                                  {field.error ? field.label : ""}
                                </InputLabel>
                                <Select
                                  name={field.name}
                                  value={field.value}
                                  onChange={field.onChange}
                                  input={
                                    <OutlinedInput
                                      name={field.name}
                                      {...(field.error && { labelWidth: 340 })}
                                      notched
                                    />
                                  }
                                >
                                  {field.options.map((option) => (
                                    <MenuItem value={option.uuid} key={option.uuid}>
                                      {field.selectLabel ? option[field.selectLabel].toUpperCase() : ""}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </StyledFormControl>
                            )}
                          </div>
                        ))}
                      </CardContent>
                    </StyledCard>
                  </Grid>
                  <Grid item xs={12} sm={6} className="mission-form-column mission-form-column-contacts">
                    <StyledCard className="mission-form-card mission-form-card-contacts" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                      <CardContent className="mission-form-card-content" style={{flex: 1}}>
                        <div className="mission-form-card-titleBlock">
                          <span className="mission-form-card-kicker">02</span>
                          <h3>Contacts et contexte</h3>
                          <p>Destinataires, localisation, contrat et delai.</p>
                        </div>
                        {[
                          {
                            label: (
                                <>
                                  DESTINATAIRES PRINCIPAUX <span style={{color: 'red'}}>*</span>
                                </>
                            ),
                            name: "principales",
                            value: destinatairePrincipale,
                            onChange: (e) => {
                              setDestinatairePrincipale(e.target.value);
                              checkDestinataireSecondaire(e.target.value);
                            },
                            type: "Select",
                            options: dataForSelects.contactsInSociete,
                            selectLabel: "nom",
                            defaultValue: "",
                            fullWidth: true,
                            ...(errors.principales && {error: true}),
                          },
                          {
                            label: "DESTINATAIRES SECONDAIRES",
                            name: "secondaires",
                            value: destinataireSecondaire,
                            onChange: (e) => setDestinataireSecondaire(e.target.value),
                            type: "SelectMultiple",
                            options: contactsInSociete.filter(item => item.uuid.toUpperCase() !== destinatairePrincipale.toLocaleUpperCase()),
                            multipleRender: (selected) =>
                                dataForSelects.contactsInSociete
                                    .filter((item) => selected.includes(item.uuid))
                                    .map((consultant) => consultant.nom)
                                    .join(", "),
                            fullWidth: true,
                          },
                          {
                            label: "EXPERIENCE",
                            name: "experience",
                            value: experience,
                            onChange: (e) => setExperience([e.target.value]),
                            type: "Select",
                            options: dataForSelects.experiencesMission,
                            selectLabel: "experience",
                            defaultValue: "",
                            fullWidth: true,
                            ...(errors.experience && {error: true}),
                          },
                          {
                            label: "FORMATION",
                            name: "formation",
                            value: formation,
                            onChange: (e) => setFormation(e.target.value),
                            type: "Select",
                            options: dataForSelects.formationsMission,
                            selectLabel: "formation",
                            defaultValue: "",
                            fullWidth: true,
                            ...(errors.formation && {error: true}),
                          },
                        ].map((field, index) => (
                            <div key={v4()}>
                              <label className="input-label" htmlFor={field.name}>
                                {field.label} {field.required && <span className="required-input">*</span>}
                              </label>
                              {field.type === "Select" && (
                                  <StyledFormControl variant="outlined" fullWidth margin="normal">
                                    <InputLabel {...(field.error && {error: true})}>
                                      {field.error ? field.label : ""}
                                    </InputLabel>
                                    <Select
                                        name={field.name}
                                        value={field.value}
                                        onChange={field.onChange}
                                        input={
                                          <OutlinedInput
                                              name={field.name}
                                              {...(field.error && {labelWidth: 325})}
                                              notched
                                          />
                                        }
                                    >
                                      {field.options.map((option) => (
                                          <MenuItem value={option.uuid} key={option.uuid}>
                                            {field.selectLabel ? option[field.selectLabel].toUpperCase() : ""}
                                          </MenuItem>
                                      ))}
                                    </Select>
                                  </StyledFormControl>
                              )}
                              {field.type === "SelectMultiple" && (
                                  <StyledFormControl variant="outlined" fullWidth margin="normal">
                                    <Select
                                        multiple
                                        name={field.name}
                                        value={field.value}
                                        onChange={field.onChange}
                                        renderValue={field.multipleRender}
                                    >
                                      {field.options.map((option) => (
                                          <MenuItem value={option.uuid} key={option.uuid}>
                                            <Checkbox checked={field.value.indexOf(option.uuid) > -1}/>
                                            <ListItemText
                                                primary={field.selectLabel ? option[field.selectLabel].toUpperCase() : (option.nom || option.experience)}
                                            />
                                          </MenuItem>
                                      ))}
                                    </Select>
                                  </StyledFormControl>
                              )}
                            </div>
                        ))}
                        <label className="input-label" htmlFor="localisation">
                          LOCALISATION
                        </label>
                        <Box>
                          <Autocomplete
                              options={villes}
                              getOptionLabel={(option) => option.name}
                              onChange={(event, value) => {
                                if (value) {
                                  setLocalisation(value.uuid);
                                } else {
                                  setLocalisation('');
                                }
                              }}
                              onInputChange={(event, newInputValue) => {
                                setInputValue(newInputValue);
                              }}
                              value={villes.find(ville => ville.uuid === localisation) || null}
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      variant="outlined"
                                      error={!!errors.localisation}
                                      helperText={errors.localisation}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                          handleAddCity();
                                        }
                                      }}
                                  />
                              )}
                          />
                        </Box>
                        <label className="input-label" htmlFor="status">
                          CONTRAT
                        </label>
                        <Box>
                          <Select
                              value={status}
                              name="status"
                              fullWidth
                              onChange={(e) => setStatus(e.target.value)}
                              {...(errors.status && {
                                error: true,
                              })}
                              input={
                                <OutlinedInput
                                    name="status"
                                    {...(errors.status && {
                                      error: true,
                                    })}
                                    notched
                                ></OutlinedInput>
                              }
                          >
                            {
                              contrats.map((contrat) => (
                                  <MenuItem value={contrat.id} key={v4()}>
                                  <span style={{textTransform: "capitalize"}}>
                                    {contrat.name}
                                  </span>
                                  </MenuItem>
                              ))
                            }
                          </Select>
                          <FormHelperText><Box sx={{color: "red"}}>{errors.status}</Box></FormHelperText>
                        </Box>
                        <label className="input-label" htmlFor="pourvoir">
                          A POURVOIR SOUS
                        </label>
                        <Box>
                          <Select
                              value={pourvoir}
                              name="pourvoir"
                              fullWidth
                              onChange={(e) => setPourvoir(e.target.value)}
                              {...(errors.pourvoir && {
                                error: true,
                              })}
                              input={
                                <OutlinedInput
                                    name="pourvoir"
                                    {...(errors.pourvoir && {
                                      error: true,
                                    })}
                                    notched
                                ></OutlinedInput>
                              }
                          >
                            {
                              pourvoirs.map((pourvoir) => (
                                  <MenuItem value={pourvoir.name} key={v4()}>
                                  <span style={{textTransform: "capitalize"}}>
                                    {pourvoir.name}
                                  </span>
                                  </MenuItem>
                              ))
                            }
                          </Select>
                          <FormHelperText><Box sx={{color: "red"}}>{errors.status}</Box></FormHelperText>
                        </Box>
                      </CardContent>
                    </StyledCard>
                  </Grid>
                  <Grid item xs={12} sm={6} className="mission-form-column mission-form-column-profile">
                    <StyledCard className="mission-form-card mission-form-card-profile" style={{flex: 1, display: "flex", flexDirection: "column"}}>
                      <CardContent className="mission-form-card-content" style={{flex: 1}}>
                        <div className="mission-form-card-titleBlock">
                          <span className="mission-form-card-kicker">03</span>
                          <h3>Profil recherche</h3>
                          <p>Competences, remuneration et contenu du poste.</p>
                        </div>
                        <label className="input-label" htmlFor="secto">
                          COMPÉTENCES SECTORIELLES
                        </label>
                        <StyledFormControl variant="outlined" fullWidth margin="normal">
                          <Select
                              name="secto"
                              multiple
                              value={sectorielle}
                              onChange={(e) => setSectorielle(e.target.value)}
                              renderValue={(selected) =>
                              dataForSelects.competencesSecto
                                .filter((item) => selected.includes(item.uuid))
                                .map((competence) => competence.secteur.toUpperCase())
                                .join(", ")
                            }
                            input={<OutlinedInput />}
                          >
                            {dataForSelects.competencesSecto.map((secto) => (
                              <MenuItem key={secto.uuid} value={secto.uuid}>
                                <Checkbox checked={sectorielle.indexOf(secto.uuid) > -1} />
                                <ListItemText primary={secto.secteur.toUpperCase()} />
                              </MenuItem>
                            ))}
                          </Select>
                        </StyledFormControl>
                        <label className="input-label" htmlFor="metier">
                          COMPÉTENCES MÉTIERS
                        </label>
                        <StyledFormControl variant="outlined" fullWidth margin="normal">
                          <Select
                            name="metier"
                            multiple
                            value={metier}
                            onChange={(e) => setMetier(e.target.value)} // Make sure `e.target.value` is an array
                            renderValue={(selected) =>
                              dataForSelects.competencesMetiers
                                .filter((item) => selected.includes(item.uuid))
                                .map((competence) => competence.metier.toUpperCase())
                                .join(", ")
                            }
                            input={<OutlinedInput />}
                          >
                            {dataForSelects.competencesMetiers.map((metierOption) => (
                              <MenuItem key={metierOption.uuid} value={metierOption.uuid}>
                                <Checkbox checked={metier.indexOf(metierOption.uuid) > -1} />
                                <ListItemText primary={metierOption.metier.toUpperCase()} />
                              </MenuItem>
                            ))}
                          </Select>
                        </StyledFormControl>
                        <label className="input-label" htmlFor="rémunération">
                          RÉMUNÉRATION
                        </label>
                        <StyledTextField
                          onChange={(e) => setRemuneration(e.target.value)}
                          name="rémunération"
                          value={remuneration}
                          placeholder="RÉMUNÉRATION"
                          margin="normal"
                          variant="outlined"
                          autoComplete="off"
                          fullWidth
                          {...(errors.remuneration && {
                            error: true,
                            label: errors.remuneration,
                          })}
                        />
                        <label className="input-label" htmlFor="poste">
                          POSTE
                        </label>
                        <EditorCustom {...editorCustomPosteProps} />
                      </CardContent>
                    </StyledCard>
                  </Grid>
                  <Grid item xs={12} sm={6} className="mission-form-column mission-form-column-content">
                    <StyledCard className="mission-form-card mission-form-card-content-rich" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                      <CardContent className="mission-form-card-content" style={{ flex: 1 }}>
                        <div className="mission-form-card-titleBlock">
                          <span className="mission-form-card-kicker">04</span>
                          <h3>Pitch et description</h3>
                          <p>Arguments mission, synthese technique et contexte societe.</p>
                        </div>
                        <label className="input-label" htmlFor="technique">
                          COMPÉTENCES TECHNIQUES
                        </label>
                        <StyledTextField
                          onChange={(e) => setTechnique(e.target.value)}
                          name="technique"
                          value={technique}
                          placeholder="COMPÉTENCES TECHNIQUES"
                          margin="normal"
                          variant="outlined"
                          autoComplete="off"
                          fullWidth
                          {...(errors.technique && {
                            error: true,
                            label: errors.technique,
                          })}
                        />
                        <label className="input-label" htmlFor="niveauAnglais">
                          NIVEAU D'ANGLAIS
                        </label>
                        <StyledFormControl variant="outlined" fullWidth margin="normal">
                          <InputLabel
                            {...(errors.niveauAnglais && {
                              error: true,
                            })}
                            shrink
                          >
                            {errors.niveauAnglais}
                          </InputLabel>
                          <Select
                            name="niveauAnglais"
                            value={niveauAnglais}
                            displayEmpty
                            onChange={(e) => setNiveauAnglais(e.target.value)}
                            {...(errors.niveauAnglais && {
                              error: true,
                            })}
                            input={
                              <OutlinedInput
                                name="metier"
                                {...(errors.niveauAnglais && {
                                  labelWidth: 320,
                                })}
                                notched
                              ></OutlinedInput>
                            }
                          >
                            {dataForSelects.niveauxAnglais.map((niveau) => (
                              <MenuItem value={niveau.uuid} key={niveau.uuid}>
                                {niveau.niveau.toUpperCase()}
                              </MenuItem>
                            ))}
                          </Select>
                        </StyledFormControl>
                        <label className="input-label" htmlFor="pitch">
                          PITCH MISSION
                        </label>
                        <EditorCustom {...editorCustomPitchMissionProps} />
                        <label className="input-label" htmlFor="description">
                          DESCRIPTION SOCIETE
                        </label>
                        <EditorCustom {...editorCustomDescriptionProps} />
                      </CardContent>
                    </StyledCard>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}
        </>
      )}
    </Box>
  );
};
export default withSnackbar(FormMission);
